export default {
  //get all CHAPTERs
  GET_ENROLLED_COURSES_REQUEST: "GET_ENROLLED_COURSES_REQUEST",
  GET_ENROLLED_COURSES_SUCCESS: "GET_ENROLLED_COURSES_SUCCESS",
  GET_ENROLLED_COURSES_FAIL: "GET_ENROLLED_COURSES_FAIL",

  ENROLLED_COURSE_REQUEST: "ENROLLED_COURSE_REQUEST",
  ENROLLED_COURSE_SUCCESS: "ENROLLED_COURSE_SUCCESS",
  ENROLLED_COURSE_FAIL: "ENROLLED_COURSE_FAIL",

  GET_PENDING_COURSES_REQUEST: "GET_PENDING_COURSES_REQUEST",
  GET_PENDING_COURSES_SUCCESS: "GET_PENDING_COURSES_SUCCESS",
  GET_PENDING_COURSES_FAIL: "GET_PENDING_COURSES_FAIL",
  //loading
  ADD_COURSES_LOADING: "ADD_COURSES_LOADING",
};
